export async function getStreetViewImage(address: string) {
  const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/streetview`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`
    },
    body: JSON.stringify({ address })
  });

  if (!response.ok) {
    throw new Error('Failed to fetch street view image');
  }

  const data = await response.json();
  return data;
}